<template>
  <div class="modal product-modal">
    <div class="overlay" @click="closeModal"></div>
    <div class="wrapper">
      <div class="container">
        <div class="form">
          <div class="form-wrapper">
            <img class="close" @click="closeModal" src="@/images/close.svg" />
            <div class="product-modal-top">
              <div class="text-container">
                <div class="text">
                  <div class="title">{{ $t("SELL YOUR SKINS") }}</div>
                  <div class="form-fields-wrapper">
                    <div class="input-container">
                      <div class="desc">{{ $t("Enter skin name") }}</div>
                      <input type="text" v-model="title" required />
                    </div>
                    <div class="input-container">
                      <div class="desc">{{ $t("Desired price") }}</div>
                      <input type="number" v-model="price" required />
                    </div>
                    <div class="input-container">
                      <div class="desc">{{ $t("Quality") }}</div>
                      <select v-model="quality" required :class="{ empty: !quality }">
                        <option value="" selected disabled>
                          {{ $t("Quality") }}
                        </option>
                        <option
                          v-for="(item, i) in qualityOptions"
                          :value="item"
                          :key="i"
                        >
                          {{ item }}
                        </option>
                      </select>
                    </div>
                    <div class="input-container">
                      <div class="desc">{{ $t("Steam inventory link to skin") }}</div>
                      <input type="text" v-model="item_url" required />
                    </div>
                  </div>
                  <div class="buttons">
                    <button class="button" @click="closeModal">
                      <span>{{ $t("CANCEL") }}</span>
                    </button>
                    <button
                      class="button dark"
                      @click="create"
                      :disabled="loading"
                    >
                      <span v-if="!loading">{{ $t("Send") }}</span>
                      <Spinner v-else />
                    </button>
                  </div>
                  <transition name="fade">
                    <div v-if="success" class="success-desc desc green">
                      {{ successMessage }}
                    </div>
                  </transition>
                  <transition name="fade">
                    <div v-if="error" class="error-desc desc red">
                      {{ error }}
                    </div>
                  </transition>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Spinner from "@/components/shared/Spinner.vue";

export default {
  name: "SaleSkinModal",
  components: {
    Spinner,
  },
  data: function () {
    return {
      title: "",
      price: "",
      quality: "",
      item_url: "",
      qualityOptions: [
        "Field-Tested",
        "Minimal Wear",
        "Battle-Scarred",
        "Well-Worn",
        "Factory New",
        "Not Painted",
      ],
      loading: false,
      error: "",
      success: false,
      successMessage: "",
    };
  },
  computed: {
    ...mapGetters("app", ["currencyCode"]),
  },
  methods: {
    ...mapActions("modals", ["closeSaleSkinModal"]),
    ...mapActions("offer", ["createOffer"]),
    closeModal() {
      this.resetForm();
      this.closeSaleSkinModal();
    },
    resetForm() {
      this.title = "";
      this.price = "";
      this.quality = "";
      this.item_url = "";
      this.error = "";
      this.success = false;
      this.successMessage = "";
      this.loading = false;
    },
    async create() {
      this.error = "";
      if (!this.title || !this.price || !this.quality || !this.item_url) {
        this.error = "Please fill in all fields.";
        return;
      }

      // Basic validation for item_url to ensure it looks like a URL
      if (!/^https?:\/\/[^\s$.?#].[^\s]*$/.test(this.item_url)) {
        this.error = "Please provide a valid URL for the Steam inventory link.";
        return;
      }

      this.loading = true;
      let data = {
        title: this.title,
        price: this.price,
        quality: this.quality,
        item_url: this.item_url,
        currency: this.currencyCode,
      };
      try {
        await this.createOffer(data);
        this.success = true;
        this.successMessage = "Offer sent successfully! We will contact you by email within 48 hours.";
        // Reset form
        this.title = "";
        this.price = "";
        this.quality = "";
        this.item_url = "";
        // Auto close after 3 seconds
        setTimeout(() => {
          this.closeModal();
        }, 3000);
      } catch (error) {
        if (error && typeof error === 'object') {
          if (error.errors) {
            let errorMessages = [];
            Object.keys(error.errors).forEach((field) => {
              if (Array.isArray(error.errors[field])) {
                errorMessages = errorMessages.concat(error.errors[field]);
              } else {
                errorMessages.push(error.errors[field]);
              }
            });
            if (errorMessages.length > 0) {
              this.error = errorMessages.join(', ');
            } else if (error.message) {
              this.error = error.message;
            } else {
              this.error = "An unknown error occurred.";
            }
          } else if (error.message) {
            this.error = error.message;
          } else {
            this.error = "An unknown error occurred.";
          }
        } else {
          this.error = "An unknown error occurred.";
        }
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.product-modal .wrapper .text-container {
  padding-top: 60px;
}

.success-desc {
  color: #28a745;
  background-color: rgba(40, 167, 69, 0.1);
  border: 1px solid #28a745;
  border-radius: 4px;
  padding: 12px;
  margin-top: 16px;
  text-align: center;
}

.error-desc {
  color: #dc3545;
  background-color: rgba(220, 53, 69, 0.1);
  border: 1px solid #dc3545;
  border-radius: 4px;
  padding: 12px;
  margin-top: 16px;
  text-align: center;
}
</style>
